import { MapPin, Phone } from "lucide-react";
import { SITE } from "../data/site";

export function MobileCallBar() {
  return (
    <div
      data-testid="sticky-mobile-call-bar"
      className="fixed inset-x-0 bottom-0 z-50 grid grid-cols-2 border-t border-gold/30 bg-ivory/95 shadow-[0_-8px_30px_rgba(43,43,43,0.12)] backdrop-blur-xl md:hidden"
      style={{ paddingBottom: "env(safe-area-inset-bottom)" }}
    >
      <a
        href={SITE.phoneHref}
        data-testid="sticky-call-button"
        className="flex items-center justify-center gap-2 bg-plum py-4 text-sm font-bold uppercase tracking-[0.12em] text-ivory transition-colors active:bg-berry"
      >
        <Phone className="h-4 w-4" aria-hidden="true" />
        Call the Shop
      </a>
      <a
        href={SITE.directionsUrl}
        target="_blank"
        rel="noopener noreferrer"
        data-testid="sticky-directions-button"
        className="flex items-center justify-center gap-2 py-4 text-sm font-bold uppercase tracking-[0.12em] text-sage transition-colors active:text-plum"
      >
        <MapPin className="h-4 w-4" aria-hidden="true" />
        Get Directions
      </a>
    </div>
  );
}
